import { useMutation } from '@apollo/client';
import { useTranslation } from 'react-i18next';
import { useNotifications, type ApiOptions } from '../helpers';
import { CopyShowDocument } from './copy.generated';

export const useCopyShow = (options: ApiOptions<typeof CopyShowDocument> = {}) => {
  const { t } = useTranslation();

  return useMutation(CopyShowDocument, {
    ...useNotifications(CopyShowDocument, {
      failure: t('api.common.error_generic'),
      success: t('api.shows.copy_success'),
    }),
    ...options,
  });
};
